/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
import React, { useRef, useEffect, Suspense } from 'react';
import { View, Text, StyleSheet, FlatList, Pressable } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import ModalizeBase from '@web-components/modals/ModalizeBase';
const ActivityIndicator = React.lazy(() =>
  import('@web-components/common/ActivityIndicator'),
);
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import Product from '@web-components/Product';
import { getSimiliarProducts } from '~store/product-detail/thunks';
import { isWeb } from '~global/screens';
import { data as Font } from '~global/Fonts';

const ModalNotifyMeSuccess = ({ navigation }) => {
  const dispatch = useDispatch();
  const modalizeRef = useRef(null);
  const isShow = useSelector((state) => state.modal.notifyMeSuccess.isShow);
  const product = useSelector((state) => state.modal.notifyMeSuccess.data);
  const products = useSelector((state) => state.productDetail.similiarProducts);
  const navigator = navigation?.current?.navigate
    ? navigation.current
    : navigation;
  const statusApiSimiliarProducts = useSelector(
    (state) => state.productDetail.status.similiarProducts,
  );
  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'notifyMeSuccess' });
  };

  const renderItem = ({ item }) => {
    return (
      <Product
        productData={item}
        key={item._id}
        navigator={navigator}
        {...(isWeb && { customWidth: 226 })}
      />
    );
  };

  const getSimiliarProductsHandler = async () => {
    const params = {
      filter: { id_product: product.id, applicable_for: 'lilla' },
    };
    await dispatch(getSimiliarProducts(params));
  };

  // useEffect(() => {
  // 	getSimiliarProductsHandler()
  // }, [])

  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
      getSimiliarProductsHandler();
    } else {
      modalizeRef.current?.close();
    }
  }, [isShow]);

  return (
    <ModalizeBase
      ref={modalizeRef}
      onClosed={closeModal}
      withInsetsBottom={true}>
      <>
        <Suspense fallback={<></>}>
          {isShow && (
            <View style={styles.modalContainer}>
              <View
                style={[
                  styles.modalHeader,
                  !products.length ? styles.modalHeaderNoProducts : {},
                ]}>
                <Text style={styles.modalHeaderHeading}>
                  Kamu akan diberitahu jika produk ini telah tersedia
                </Text>
                <Pressable style={styles.modalDismiss} onPress={closeModal}>
                  <WithLocalSvg
                    key="dismiss"
                    width={14}
                    height={14}
                    asset={require('~assets/img/common/modal-dismiss.svg')}
                    onPress={closeModal}
                  />
                </Pressable>
              </View>

              <View style={styles.modalBody}>
                {statusApiSimiliarProducts === 'succeeded' && (
                  <>
                    {products.length > 0 && (
                      <View>
                        <Text style={styles.modalHeading}>
                          Barangkali kamu juga suka ini :
                        </Text>

                        <FlatList
                          contentContainerStyle={styles.productGridHorizontal}
                          data={products}
                          renderItem={renderItem}
                          keyExtractor={(item) => item._id}
                          horizontal={true}
                          showsHorizontalScrollIndicator={false}
                        />
                      </View>
                    )}
                  </>
                )}

                {statusApiSimiliarProducts === 'pending' && (
                  <ActivityIndicator />
                )}
              </View>
            </View>
          )}
        </Suspense>
      </>
    </ModalizeBase>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    ...(isWeb && { width: 522 }),
  },
  modalDismiss: {
    position: 'absolute',
    right: 16,
    top: 16,
  },
  modalHeader: {
    position: 'relative',
    backgroundColor: '#F3F0FC',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 98,
    marginBottom: 24,
  },
  modalHeaderHeading: {
    ...Font.poppinsMedium,
    fontSize: 16,
    lineHeight: 24,
    color: '#25182E',
    width: 230,
    textAlign: 'center',
  },
  modalHeading: {
    fontFamily: 'satoshi-black',
    fontSize: 16,
    lineHeight: 20,
    color: '#25182E',
    marginBottom: 12,
    paddingHorizontal: 16,
  },
  productGridHorizontal: {
    paddingBottom: 24,
    paddingRight: 8,
  },
  modalHeaderNoProducts: {
    height: '100%',
  },
});

export default ModalNotifyMeSuccess;
